import { gql } from '@apollo/client';

export const GET_STORES = gql`
  query getStores($storesFilter: StoresFilter!) {
    stores(storesFilter: $storesFilter) {
      id
      name
      address
      state
      timezone
      latlng
      storeNumber
      archived
      brands {
        id
        name
      }
      users {
        id
        firstName
        lastName
      }
      storeManagerUsers {
        id
        firstName
        lastName
      }
      tags {
        id
        name
        displayColour
        archived
      }
    }
  }
`;
